module.exports = __webpack_public_path__ + "static/media/11.5bb8c31e.jpg";